import React from "react";

const RestartDialogBody = ()  =>
    <div className="sign-dialog">
            <div className="sign-dialog--task">
                Are you sure? Click yes to clear approvals and edit or delete the Exception Form. The Approval Workflow must be re-started from the beginning after being Reset.
            </div>
    </div>

export default RestartDialogBody;